<template>
  <div class="checkbox">
    <input
      v-bind="$attrs"
      :id="props.id ?? id"
      v-model="model"
      type="checkbox"
    />
    <label :for="props.id ?? id">
      <slot />
    </label>
  </div>
</template>

<script lang="ts" setup>
import { computed, ComputedRef, inject } from "vue";
import { ValidationUtils } from "@/types";

const props = defineProps<{
  modelValue: boolean;
  id?: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const validationUtils =
  inject<ComputedRef<ValidationUtils>>("field-validation");
const id = inject<string>("field-id");

const model = computed({
  get: () => props.modelValue,
  set: (value: boolean) => {
    emit("update:modelValue", value);
    validationUtils?.value.onChange(value);
    validationUtils?.value.touch();
  },
});
</script>
